import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import MainLayout from "../../../components/MainLayout";
import { useNavigate } from "react-router-dom";
import { RxExclamationTriangle } from "react-icons/rx";
import { TbClipboardCheck, TbLoader } from "react-icons/tb";
import MessageUser from "../../../components/MessageUser";

import { getAllNotifications, updateNotification } from "../../../helpers/Api";

const Mensajes = () => {
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [allNotifications, setAllNotifications] = useState([]);
  const [query, setQuery] = useState(0);
  const navigate = useNavigate();

  //pagination
  const itemsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    getNotifications();
  }, [itemOffset]);

  const getNotifications = async () => {
    try {
      const response = await getAllNotifications(
        itemOffset,
        itemsPerPage,
        token
      );
      if (response) {
        response?.count === itemsPerPage
          ? setPageCount(1)
          : setPageCount(Math.ceil(response?.count / itemsPerPage));
        setAllNotifications(response.results);
      }
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    const dateShortener = date.slice(0, 10);
    return dateShortener;
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const notificationHandler = async (value) => {
    try {
      const fecha_visto = new Date().toJSON().slice(0, 10);
      const response = await updateNotification(
        value.id,
        { fecha_visto: fecha_visto },
        token
      );
      if(role === 'ASC' && value?.tipo === 'CAG') {      
        navigate(`/perfil-agente/${value.param_3}/detalle-operaciones/${value.param_1}/#comentarios`); 
        setQuery(query + 1);
      } 
      else if(role === 'ASC' && value?.tipo === 'CMA'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        setQuery(query + 1);
      }
        else if(role === 'ASC' && value?.tipo === 'CAL'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        setQuery(query + 1);
      }
       else if(role === 'ASC' && value?.tipo === 'CMD'){
        navigate(`/perfil-agente/${value.param_3}/#generales`); 
        setQuery(query + 1);
      }
        else if (role === 'AGA' && value?.tipo === 'CAA') {
        navigate(`/detalle-operaciones/${value.param_1}/#comentarios`);
        setQuery(query + 1)
      } else {
        navigate(`/`);
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>NOTIFICACIONES</h5>
        </div>
      </div>
      <div className="row table_body">
        {loading ? (
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "4rem" }}
          >
            <TbLoader
              color={"rgb(10, 132, 254)"}
              className="loader"
              size={"3rem"}
            />
          </div>
        ) : (
          <>
            <div className="col-12 table-responsive mt-4">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Recibido</th>
                    <th scope="col">Mensaje</th>
                    <th scope="col" style={{ textAlign: "center" }}>Estatus</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                {allNotifications ? (
                  allNotifications.map((value, index) => (
                    <tbody key={index}>
                      <tr>
                        <td className="w-25">{formatDate(value.fecha_creacion)}</td>
                        <td className="w-50" style={{ textAlign: "left" }}>
                        <MessageUser 
                        messageType={value?.tipo} 
                        param1={value?.param_1} 
                        param2={value.param_2} 
                        param3={value.param_3} 
                        param4={value.param_4}/>
                        </td>
                        <td className="w-25" style={{ textAlign: "center", paddingTop: '26px' }}>
                          {" "}
                          {!value.fecha_visto ? (
                            <span
                              className="mediaBadge"
                              style={{ borderRadius: "8px", padding: "4px" }}
                            >
                              Sin Revisar
                            </span>
                          ) : (
                            <span
                              className="terminadoBadge"
                              style={{ borderRadius: "8px", padding: "4px" }}
                            >
                              Revisado
                            </span>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn"
                            onClick={() => notificationHandler(value)}
                          >
                            <TbClipboardCheck size={"19px"} />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  ))
                ) : (
                  <div className="row d-flex flex-row">
                    <div className="col-12 dropdown_menu_inside d-flex justify-content-center">
                      <button className="btn d-flex flex-row">
                        <div>
                          <p>
                            <RxExclamationTriangle
                              size={"20px"}
                              style={{ color: "#2F76FF", margin: "0" }}
                            />{" "}
                            Sin notificaciones
                          </p>
                          <p style={{ fontFamily: "Inconsolata" }}></p>
                        </div>
                      </button>
                    </div>
                  </div>
                )}
              </table>
            </div>
          </>
        )}
      </div>
      <div className="row">
        <div className="col-12 d-flex justify-content-end paginationList">
          <ReactPaginate
            breakLabel="..."
            nextLabel="Siguiente"
            onPageChange={handlePageClick}
            pageRangeDisplayed={10}
            pageCount={pageCount}
            previousLabel="Anterior"
            renderOnZeroPageCount={null}
            containerClassName="pagination my-5 mx-auto"
            subContainerClassName="pages pagination"
            activeClassName="active"
            breakClassName="break-me"
            className="pagination"
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default Mensajes;
